/**
 * Copyright (c) 2017-2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { Column } from '../../../../mol-data/db';
var Schema = Column.Schema;
var str = Schema.str;
var float = Schema.float;
var datablock = {
  id: str,
  description: str
};
var dictionary = {
  title: str,
  datablock_id: str,
  version: str
};
var dictionary_history = {
  version: str,
  update: str,
  revision: str
};
var sub_category = {
  id: str,
  description: str
};
var category_group_list = {
  id: str,
  parent_id: str,
  description: str
};
var item_type_list = {
  code: str,
  primitive_code: str,
  construct: str,
  detail: str
};
var item_units_list = {
  code: str,
  detail: str
};
var item_units_conversion = {
  from_code: str,
  to_code: str,
  operator: str,
  factor: float
}; // TODO save frame dic schema

export var dic_Schema = {
  datablock: datablock,
  dictionary: dictionary,
  dictionary_history: dictionary_history,
  sub_category: sub_category,
  category_group_list: category_group_list,
  item_type_list: item_type_list,
  item_units_list: item_units_list,
  item_units_conversion: item_units_conversion
};